/**
 * Куда положить облако подсказки.
 *
 * Облако рисуется порталом в body с position: fixed, а не внутри панели: сайдбар
 * скроллится по вертикали, и всё, что вылезает за его борт, обрезается — облако
 * шириной с панель читалось бы огрызком.
 *
 * Правило простое: справа от значка, если справа есть место; иначе слева. И в
 * любом случае целиком в пределах окна — на планшете сайдбар занимает пол-экрана,
 * и «справа» там может не быть вовсе.
 */
export const HINT_WIDTH = 260
/** Отступ от значка и от краёв окна. */
export const HINT_GAP = 8

export interface AnchorRect {
  left: number
  right: number
  top: number
  bottom: number
}

export interface Viewport {
  width: number
  height: number
}

export interface HintPlacement {
  left: number
  top: number
  /** С какой стороны от значка встало облако (для «хвостика»). */
  side: 'right' | 'left'
}

export function hintPlacement(
  anchor: AnchorRect,
  viewport: Viewport,
  bubbleHeight: number,
): HintPlacement {
  const rightLeft = anchor.right + HINT_GAP
  const fitsRight = rightLeft + HINT_WIDTH <= viewport.width - HINT_GAP
  const leftLeft = anchor.left - HINT_GAP - HINT_WIDTH
  const fitsLeft = leftLeft >= HINT_GAP

  // Справа — по умолчанию; слева — только если справа не влезает, а слева влезает.
  // Когда не влезает нигде (окно уже облака), прижимаем к левому краю: обрезанное
  // облако хуже наехавшего.
  const side: 'right' | 'left' = fitsRight || !fitsLeft ? 'right' : 'left'
  const rawLeft = side === 'right' ? rightLeft : leftLeft
  const left = Math.max(HINT_GAP, Math.min(rawLeft, viewport.width - HINT_WIDTH - HINT_GAP))

  // По вертикали держим верх облака у значка, но не даём уехать за нижний край:
  // подсказки у нижних разделов панели иначе оказались бы за экраном.
  const maxTop = viewport.height - bubbleHeight - HINT_GAP
  const top = Math.max(HINT_GAP, Math.min(anchor.top, maxTop))

  return { left, top, side }
}
